import { AxiosInstance, AxiosRequestConfig } from "axios"

export interface GenerateShareLinkRequest extends Partial<AxiosRequestConfig> {
  data?: {
    propertyId: string
    preQuoteId?: string | null
  }
  params?: {
    agentId?: number
  }
}

export interface GenerateShareLinkResponseData {
  linkId: number
  token: string
  shareUrl: string
  propertyId: string
  expiresAt: string
}

export interface GenerateShareLinkResponse {
  apiStatus: string
  data: GenerateShareLinkResponseData
}

export function generateShareLinkApi(
  { data, params, ...config }: GenerateShareLinkRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: "/share-link/generate",
    data,
    params,
    ...config,
  }) as Promise<{ data: GenerateShareLinkResponse }>
}
